<div class="control-line mat-elevation-z8">
  <div class="filter-actions-line" style="box-shadow: none !important; background-color: rgba(255, 255, 255, 0.8) !important; ">

    <app-select-search (selectedItemId)="onStatusReceived($event)" [selectItems]="statusInfo" selectTitle="Status">        
    </app-select-search>
    <mat-form-field appearance="outline">
      <mat-label>WorkOrder#</mat-label>
      <input matInput placeholder="Workorder#" [(ngModel)]="workOrderNo" data-testId="txtWorkorderno" />
    </mat-form-field>

    <!-- months-select.component.html -->
    <mat-form-field appearance="outline">
      <mat-label>Enter a date range</mat-label>
      <mat-date-range-input id="dtRange" data-testid="dtRange" [formGroup]="range" [rangePicker]="picker">
        <input matStartDate id="startDateInput" placeholder="Start date" formControlName="start" (blur)="dateformat($event)" (keydown)="onKeydown($event)">
        <input matEndDate id="endDateInput" placeholder="End date" formControlName="end" (blur)="dateformat($event)" (keydown)="onKeydown($event)">
      </mat-date-range-input>
      <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>
    <button id="toteinvbtn" data-testid="toteinvbtn" mat-raised-button color="primary" (click)="InvoiceSearch()">
      Search
    </button>
    @if(controlPermissions.reprocess){
      <button style="margin-left: auto;" id="reproinv" data-testid="reproinv" mat-raised-button
        color="primary" (click)="ReprocessInvoice()">
        Reprocess
      </button>
    }
    @if(controlPermissions.generateReport){
      <button style="margin-left: auto;" id="reproinv" data-testid="monendprocess" mat-raised-button
        color="primary" (click)="RunMonthEndProcess()">
        Run Month End Process
      </button>
    }
  </div>
</div>

<div class="gridheight mat-elevation-z8 viewport table-container" >
  <table mat-table [dataSource]="dataSource" class="viewport" matSort>
    <!-- Work Order Number Column -->
    <ng-container matColumnDef="workOrderNumber">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Work Order Number </th>
      <td mat-cell *matCellDef="let element"> {{element.workOrderNumber}} </td>
    </ng-container>
    <!-- Reprocess Column -->
    <ng-container matColumnDef="response">
      <th mat-header-cell *matHeaderCellDef> Message/Transaction # </th>
      <td mat-cell *matCellDef="let element">
        {{element.response}}
      </td>
    </ng-container>

    <!-- Status Code Column -->
    <ng-container matColumnDef="statusCode">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Status </th>
      <td mat-cell *matCellDef="let element"> {{element.statusCode}} </td>
    </ng-container>


    <ng-container matColumnDef="reprocess">
      <th mat-header-cell *matHeaderCellDef>Reprocess</th>
      <td mat-cell *matCellDef="let element">
        <mat-checkbox [(ngModel)]="element.isSelected"></mat-checkbox>
      </td>
    </ng-container>

    <!-- Request Payload Column --> 
    <ng-container matColumnDef="request">
      <th mat-header-cell *matHeaderCellDef> Request Payload </th>
      <td mat-cell *matCellDef="let element" class="request-cell">
        <button mat-raised-button color="warn" (click)="showPayloadRequest(element.request)" class="btn-payload">
          ...
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

    <!-- No Data Row -->
    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" [attr.colspan]="displayedColumns.length"
        style="color: red;text-align: center;font-weight: 500;">
        No data available.
      </td>
    </tr>
  </table>

</div>

